import { HelpPage } from "@homesite/ui";
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";

export const helpRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/help",
	component: HelpPage,
});
